import React from 'react'
import './Header.css'

function Heading() {
  return (
    <div className='mx-auto products mt-5'>
      <p class="text-center fs-1 mt-16">All Products</p>
      <hr className='mx-auto line'/>
    </div>
  )
}

export default Heading
